module.exports = __webpack_public_path__ + "static/media/1.958df474.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instructorsPhoto/1.jpg
// module id = 242
// module chunks = 1